import React from "react";

import Typography from "@mui/material/Typography";
import styled from "styled-components";

import Container from "../components/layout/Container";
import FileWrapper, { useFileContext } from "../components/context/FileWrapper";
import Dropzone from "../components/forms/Dropzone";
import Button from "../components/shared/Button";
import FilesList from "../components/documents/FilesList";
import ErrorUpload from "../components/documents/ErrorUpload";
import SuccessUpload from "../components/documents/SuccessUpload";
import Modal from "../components/shared/Modal";
import FullScreenLoader from "../components/shared/FullScreenLoader";

const Upload = () => {
  const {
    submit,
    clearAllAssociation,
    displayMsg,
    closeMsg,
    isError,
    isLoading,
  } = useFileContext();

  return (
    <Container
      navbarProps={{
        title: (
          <Typography color="var(--text-color)" fontSize={26} fontWeight={700}>
            Upload Doc
          </Typography>
        ),
      }}
    >
      <StyleWrapper className="upload-doc d-flex flex-column">
        <div className="upload-doc__main d-flex flex-column flex-grow-1">
          <Dropzone />
          <FilesList />
        </div>
        <div className="upload-doc__action d-flex justify-content-center">
          <Button
            size="small"
            icon={<img src="/assets/icons/doc-dissociate.svg" alt="" />}
            onClick={clearAllAssociation}
          >
            Tout dissocier
          </Button>
          <Button
            size="small"
            color="primary"
            variant="contained"
            icon={
              <img src="/assets/icons/doc-validate-association.svg" alt="" />
            }
            onClick={submit}
            disabled={isLoading}
          >
            Valider les associations
          </Button>
        </div>
        <Modal open={displayMsg} handleClose={closeMsg}>
          {isError ? <ErrorUpload /> : <SuccessUpload handleClose={closeMsg} />}
        </Modal>
      </StyleWrapper>
      <FullScreenLoader open={isLoading} />
    </Container>
  );
};

const StyleWrapper = styled.div`
  &.upload-doc {
    height: 100%;
    gap: 40px;
    padding: 10px;
  }

  .upload-doc__main {
    background-color: #f9f9fa;
    padding: 30px;
    border-radius: 20px;
  }

  .upload-doc__action {
    gap: 15px;

    button img {
      margin-right: 5px;
    }
  }
`;

export default () => (
  <FileWrapper>
    <Upload />
  </FileWrapper>
);
